var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h4',[_vm._v(" Error ")]),_c('h1',[_vm._v(" 403 ")]),_c('a',{staticStyle:{"text-decoration":"none"},on:{"click":function($event){return _vm.routeToHome()}}},[_vm._v(" Back to the website ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }